import { useEffect, useState } from 'react';
import {
  useRecordContext,
  TextField,
  TextFieldProps,
  RaRecord
} from 'react-admin';
import { secondsToHHMMss } from 'shared/utils/date';


function DurationField({ ...props }: TextFieldProps): JSX.Element {
  const record = useRecordContext();
  const [remainingTime, setDuration] = useState(null);

  const analysis = record?.analysis ?? record

  useEffect(() => {
    let interval: NodeJS.Timer | undefined;
    const { status, duration } = analysis
    if ((status === "running" || status === "in-progress") && analysis.startedAt) {
      interval = setInterval(() => {
        setDuration(getDuration(analysis));
      }, 1000);
    }else {
      setDuration(secondsToHHMMss(duration))
      clearInterval(interval)
    }
    return () => clearInterval(interval);
  }, [analysis]);

  return <TextField {...props} source="formatted" record={{ ...record, formatted: remainingTime }} />
}

export default DurationField

function getDuration(record : RaRecord){
  if(record.startedAt){
    const startDate = new Date(record.startedAt + "Z")
    return secondsToHHMMss((new Date().getTime() - startDate.getTime())/1000 )
  }
  return undefined
} 
